import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.scss']
})
export class SettingsComponent implements OnInit {

  allLang = [];
  _trans: any;

  settings = {
    lang: "en", // en, fa, ar
    marja: 'Ayatullah Khamenei',
    dir: 'ltr',
  }

  constructor(private http: HttpClient) {
    // this._trans.getDataFile();
    this.loadTranslationFile();

    var settings = localStorage.getItem('settings');
    var settingsLocal = JSON.parse( settings );

    
    if( settings != null ) {
      this.settings = settingsLocal;
    }
  }

  loadTranslationFile() {
    var sheet_url = "/assets/translations.json?"+ Math.random();


    this.http.get(sheet_url).subscribe(
      data => this._trans = Object.values(data)[2],
      error => alert(error),
      () => {
        var allLang = this._trans[0];
        allLang.splice(0,1);
        
        for (var k = 0; k < allLang.length; ++k) {
          var lang = allLang[k].split("|")
          this.allLang[k] = lang;
        }

        return this.allLang;
      }
    );

  }



  saveSettings(event: any) {   
    for (var k = 0; k < this.allLang.length; ++k) {
      if( this.allLang[k][0] == this.settings.lang ) {
        this.settings.dir = this.allLang[k][2];
      }
    }

    localStorage.setItem('settings', JSON.stringify(this.settings));
    window.location.href = "/";
  }


  ngOnInit() {
  }

}
